import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { ItemBillingEnds, ItemBillingEndsAfterInterval, RecurringBillingInterval, SubscriptionStatus } from "../enums";
import { IAPIRelatedSubscriptionGridModel } from "../interfaces"; 

export class RelatedSubscriptionGridModel {
    id: string;
    lastPaid?: Date;
    nextDue?: Date;
    status: keyof typeof SubscriptionStatus;
    pastDueDays: number;
    createdDate: Date;
    amount: number;
    billingInterval: keyof typeof RecurringBillingInterval;
    billingIntervalCount: number;
    billingEndsInterval: keyof typeof ItemBillingEnds;
    billingEndsAfterInterval: keyof typeof ItemBillingEndsAfterInterval;
    billingEndIntervalCount: number;
    constructor(data?: Partial<RelatedSubscriptionGridModel>) {
        this.id = (data && data.id) || '';
        this.lastPaid = (data && data.lastPaid && new Date(data.lastPaid)) || undefined;
        this.nextDue = (data && data.nextDue && new Date(data.nextDue)) || undefined;
        this.status = (data && data.status) || SubscriptionStatus.Active;
        this.pastDueDays = (data && data.pastDueDays) || 0;
        this.createdDate = (data && data.createdDate) || new Date();
        this.amount = (data && data.amount) || 0;
        this.billingInterval = (data && data.billingInterval) || RecurringBillingInterval.Month;
        this.billingIntervalCount = (data && data.billingIntervalCount) || 1;
        this.billingEndsInterval = (data && data.billingEndsInterval) || ItemBillingEnds.After;
        this.billingEndsAfterInterval =
            (data && data.billingEndsAfterInterval) ||
            (ItemBillingEndsAfterInterval.Month as keyof typeof ItemBillingEndsAfterInterval);
        this.billingEndIntervalCount = (data && data.billingEndIntervalCount) || 1;
    }

    static deserializeAPIModel(data: IAPIRelatedSubscriptionGridModel): RelatedSubscriptionGridModel {
        const mappedData: Partial<RelatedSubscriptionGridModel> = {
            id: data.id,
            lastPaid: data.lastPaid ? UtilityMethods.removeZFromDateString(data.lastPaid) : undefined,
            nextDue: data.nextDue ? UtilityMethods.removeZFromDateString(data.nextDue) : undefined,
            status: data.status as keyof typeof SubscriptionStatus,
            pastDueDays: data.pastDueDays,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
            amount: data.amount,
            billingInterval: data.billingInterval as keyof typeof RecurringBillingInterval,
            billingEndIntervalCount: data.billingEndIntervalCount,
            billingEndsAfterInterval: data.billingEndsAfterInterval as keyof typeof ItemBillingEndsAfterInterval,
            billingEndsInterval: data.billingEndsInterval as keyof typeof ItemBillingEnds,
            billingIntervalCount: data.billingIntervalCount,
        };
        return new RelatedSubscriptionGridModel(mappedData);
    }
}
